require("../../base/js/app.js");
require('bootstrap-datepicker');




// WEBPACK FOOTER //
// ./resources/assets/sanquin/js/app.js